module.exports = __webpack_public_path__ + "img/thisis.80c221a4.png";